export interface IListViewElement {
    label?: string;
    key: string;
    visible: number;
}
